import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { Avatar, Box, Divider, Stack, styled, Typography } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { allIcons } from "../../../assets";
import TextInput from "../../../components/TextInputs";
import UserData from "../../../dumyData/Clients.json";
import { setSelectedClient } from "../../../lib/CompanySlice/SelectedClientSlice";
import globalStyle from "../../../globalStyle";
import { t } from "i18next";

const CustomAvatar = styled(Avatar)(({ theme }) => ({
  boxShadow: "1px 1px 5px 0px #00000040",
  backgroundColor: "#ffffff",
}));

const AddOrSelectClient = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box height={"100vh"} display={"flex"} flexDirection={"column"}>
      <Stack p={2} gap={2}>
        <Typography variant="h1" fontSize={"1.5rem"} fontWeight={500}>
          {t("selectClient")}
        </Typography>
        <TextInput
          placeholder={t("searchClientOrEmpty")}
          styleProps={globalStyle.textField}
          InputStartIcon={
            <img src={allIcons.searchIcon} alt="seach-icon" width={20} />
          }
        />

        <Stack
          direction={"row"}
          gap={1.5}
          alignItems={"center"}
          sx={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/dashboard/clients");
          }}
        >
          <CustomAvatar>
            <AddOutlinedIcon htmlColor="#000000" />
          </CustomAvatar>
          <Typography variant="body2" fontWeight={500}>
            {t("addNewClient")}
          </Typography>
        </Stack>
      </Stack>
      <Divider />
      <Stack
        p={2}
        gap={2}
        overflow={"auto"}
        sx={{
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        {UserData.map((val, ind) => {
          return (
            <Stack
              key={ind}
              gap={1.5}
              direction={"row"}
              alignItems={"center"}
              sx={{ cursor: "pointer" }}
              onClick={() => {
                dispatch(setSelectedClient(val));
              }}
            >
              <CustomAvatar src={val.image} />
              <Box>
                <Typography variant="body2" fontWeight={500} noWrap>
                  {val.name}
                </Typography>
                <Typography variant="body2" fontSize={"0.75rem"} noWrap>
                  {val.email}
                </Typography>
              </Box>
            </Stack>
          );
        })}
      </Stack>
    </Box>
  );
};

export default AddOrSelectClient;
